declare function require(path: string);
import { Component, OnInit } from '@angular/core';
import { Client } from '../../../interfaces/Client.interface';

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.css']
})
export class PlanComponent implements OnInit {

  public infoCliente: Client;
  public esquemaPlan: string;
  public viewPlan:boolean=true;


  constructor() { }

  ngOnInit() {
    if(localStorage.getItem('infoClient')){
      this.infoCliente=JSON.parse(localStorage.getItem('infoClient'));
    }

    

    setInterval(()=>{
      this.selectCategory();
    },500);
    
  }

  public selectCategory():void{
    console.log(this.infoCliente.category.id+'/'+this.infoCliente.level.id);

    let lang = sessionStorage.getItem('lang');
    
    switch(this.infoCliente.category.id){
        case '1':
            if(this.infoCliente.level.id==='1'){
              this.esquemaPlan="../../../assets/images/esq_suministrador_embajador_"+lang+".png";
            }else if(this.infoCliente.level.id==='2'){
              this.esquemaPlan="../../../assets/images/esq_suministradores_"+lang+".png";
            }else if(this.infoCliente.level.id==='3'){
              this.esquemaPlan="../../../assets/images/esq_suministradores_"+lang+".png";
            }
        break;
        case '2':
            if(this.infoCliente.level.id==='4'){
              this.esquemaPlan="../../../assets/images/esq_asociaciones_"+lang+".png";
            }else if(this.infoCliente.level.id==='5'){
              this.esquemaPlan="../../../assets/images/esq_asociaciones_"+lang+".png";
            }else if(this.infoCliente.level.id==='6'){
              this.viewPlan=false;
            }else if(this.infoCliente.level.id==='8'){
              this.esquemaPlan="../../../assets/images/esq_asociaciones_"+lang+".png";
            }
        break;
        case '3':

            if(this.infoCliente.level.id==='7'){
              this.viewPlan=false;
            }
        break;
    }
}

}
